export default "__VITE_ASSET__BrS8duWe__"